// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetTextContentByIdRequestModel from '../../model/get-text-content-by-id-request-model';
import UpdateTextContentRequestModel from '../../model/update-text-content-request-model';
import GetTextContentPagedListRequestModel from '../../model/get-text-content-paged-list-request-model';
import GetScopeLookupRequestModel from '../../model/get-scope-lookup-request-model';
import DownloadTextContentReportRequestModel from '../../model/download-text-content-report-request-model';
import TextContentModel from '../../model/text-content-model';
import TextContentTranslationPagingResultModel from '../../model/text-content-translation-paging-result-model';
import Int64LookupListResultModel from '../../model/int64-lookup-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getTextContentById(request: GetTextContentByIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetTextContentByIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-text-content-by-id'] ?? 'core/textContents/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(TextContentModel.toModel(dto));
  },
  /**  */
  async updateTextContent(request: UpdateTextContentRequestModel, config?: RequestConfig) {
    const requestDTO = UpdateTextContentRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-text-content'] ?? 'core/textContents/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.put<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        textContentKey: requestDTO.textContentKey,
        scope: requestDTO.scope,
        originalContent: requestDTO.originalContent,
        originalLanguage: requestDTO.originalLanguage,
        translations: requestDTO.translations,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(TextContentModel.toModel(dto));
  },
  /**  */
  async getTextContentPagedList(request: GetTextContentPagedListRequestModel, config?: RequestConfig) {
    const requestDTO = GetTextContentPagedListRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-text-content-paged-list'] ?? 'core/textContents';
    const response = await service.get<any>(endpointPath, {
      query: {
        scope: requestDTO.scope,
        language: requestDTO.language,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(TextContentTranslationPagingResultModel.toModel(dto));
  },
  /**  */
  async getScopeLookup(request: GetScopeLookupRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-scope-lookup'] ?? 'core/textContents/scopes/lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
  /**  */
  async downloadTextContentReport(request: DownloadTextContentReportRequestModel, config?: RequestConfig) {
    const requestDTO = DownloadTextContentReportRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-download-text-content-report'] ?? 'core/textContents/report';
    const response = await service.post<any>(endpointPath, {
      responseType: 'blob',
      query: {
        scope: requestDTO.scope,
        language: requestDTO.language,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(new Blob([result], { type: 'application/octet-stream' }));
  },
});
